var _defs, _path, _circle, _path2, _path3, _circle2, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSelfOnboardedStudents(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.111,
    height: 32,
    viewBox: "0 0 25.111 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#1877f2;}.b{fill:#1157b3;}.c{fill:#42c505;}.d{fill:#359e04;}.e{fill:#f7f7ff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M24.566,30H33.7a4.566,4.566,0,0,1,4.566,4.566v7.609A1.522,1.522,0,0,1,36.741,43.7H21.522A1.522,1.522,0,0,1,20,42.175V34.566A4.566,4.566,0,0,1,24.566,30Z",
    transform: "translate(-20 -16.303)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 5.327,
    cy: 5.327,
    r: 5.327,
    transform: "translate(3.805 0)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M36.741,44.522H21.522A1.522,1.522,0,0,1,20,43v2.283A1.522,1.522,0,0,0,21.522,46.8H36.741a1.522,1.522,0,0,0,1.522-1.522V43A1.522,1.522,0,0,1,36.741,44.522Z",
    transform: "translate(-20 -19.411)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M30.327,23.968a5.319,5.319,0,0,0,5.2-6.468,5.327,5.327,0,0,1-10.4,0,5.319,5.319,0,0,0,5.2,6.468Z",
    transform: "translate(-21.195 -13.315)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 6.849,
    cy: 6.849,
    r: 6.849,
    transform: "translate(11.414 18.263)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M41.848,49.207A6.845,6.845,0,0,1,35.1,43.5a6.849,6.849,0,1,0,13.492,0,6.845,6.845,0,0,1-6.746,5.707Z",
    transform: "translate(-23.586 -19.53)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M45.609,42.044H44.088V40.522a1.522,1.522,0,0,0-3.044,0v1.522H39.522a1.522,1.522,0,1,0,0,3.044h1.522v1.522a1.522,1.522,0,1,0,3.044,0V45.088h1.522a1.522,1.522,0,1,0,0-3.044Z",
    transform: "translate(-24.303 -18.454)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelfOnboardedStudents);
export default __webpack_public_path__ + "static/media/self-onboarded-students.f09a6980352d7acedd771e92983714b1.svg";
export { ForwardRef as ReactComponent };